import { Link } from 'react-router-dom';

export default function ArticlePreview() {
  return (
    <section className="py-20 md:py-28 bg-background-100 relative overflow-hidden">
      {/* Subtle mesh gradient */}
      <div className="absolute inset-0 bg-mesh opacity-50"></div>
      {/* Top & bottom gradient dividers */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-background-300/50 to-transparent"></div>
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-background-300/50 to-transparent"></div>
      {/* Decorative floating orb */}
      <div className="bg-orb bg-orb-accent w-[280px] h-[280px] -top-[80px] right-[10%] animate-orb-float opacity-40"></div>

      <div className="max-w-[1280px] mx-auto px-4 md:px-6 relative">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-[40%]">
            <div className="rounded-3xl overflow-hidden h-[320px] md:h-[420px] relative group cursor-pointer">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20dashboard%20spreadsheet%20interface%20with%20product%20thumbnails%20and%20data%20on%20warm%20cream%20background%2C%20soft%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20beige%20tones%2C%20minimalist%20UI%20mockup%2C%20clean%20composition%2C%20elegant%20data%20visualization%2C%20no%20text%2C%20sophisticated%20tech%20aesthetic%2C%20soft%20shadows&width=800&height=840&seq=article-cover-guide&orientation=portrait"
                alt="CSSBuy Sheet Complete Guide 2026"
                title="CSSBuy Spreadsheet Guide"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>

          <div className="w-full lg:w-[60%] flex flex-col">
            <span className="text-xs text-foreground-400 font-medium tracking-wide uppercase">
              SEO Guide — Updated Daily
            </span>
            <h2 className="font-heading font-bold text-[28px] md:text-[32px] text-foreground-950 mt-2 leading-tight">
              How to Use CSSBuy Sheet
              <br />
              <span className="text-foreground-300">in 2026</span>
            </h2>
            <blockquote className="mt-5 text-base md:text-lg text-foreground-600 leading-relaxed max-w-[540px] italic border-l-3 border-accent-400 pl-5">
              "CSSBuy spreadsheets have revolutionized the way shoppers discover and purchase quality fashion items. This comprehensive guide walks you through everything from finding the best CSSBuy sheet links to understanding QC photos, trusted seller verification, and navigating the latest spreadsheet directories."
            </blockquote>
            <p className="mt-4 text-sm text-foreground-500 font-medium">
              — by CSSBuy Spreadsheet Experts
            </p>

            <div className="flex items-center gap-3 mt-8">
              <Link
                to="/article/cssbuy-sheet-guide"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                Read Full Guide
                <i className="ri-arrow-right-line text-base"></i>
              </Link>
              <Link
                to="/article/cssbuy-sheet-guide"
                className="inline-flex items-center gap-2 w-10 h-10 rounded-full border border-foreground-200 text-foreground-500 hover:bg-background-50 hover:text-foreground-800 transition-all duration-200 justify-center cursor-pointer"
              >
                <i className="ri-arrow-right-up-line text-lg"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}